module.exports = __webpack_public_path__ + "img/news_17-06-2019.e4d2393d.jpg";